import apiClient from '../config/api';

const productSkuService = {
  /**
   * Get all SKUs for a product
   * @param {number} productId - Product ID
   * @returns {Promise} Array of SKUs
   */
  getSkusByProduct: async (productId) => {
    const response = await apiClient.get(`/productsku/product/${productId}`);
    return response.data;
  },

  /**
   * Get active SKUs for a product
   * @param {number} productId - Product ID
   * @returns {Promise} Array of active SKUs
   */
  getActiveSkusByProduct: async (productId) => {
    const response = await apiClient.get(`/productsku/product/${productId}/active`);
    return response.data;
  },

  /**
   * Get SKU by ID
   * @param {number} id - SKU ID
   * @returns {Promise} SKU details
   */
  getSkuById: async (id) => {
    const response = await apiClient.get(`/productsku/${id}`);
    return response.data;
  },

  /**
   * Create a new SKU
   * @param {object} skuData - SKU data
   * @returns {Promise} Created SKU
   */
  createSku: async (skuData) => {
    const response = await apiClient.post('/productsku', skuData);
    return response.data;
  },

  /**
   * Update SKU
   * @param {number} id - SKU ID
   * @param {object} skuData - Updated SKU data
   * @returns {Promise} Update result
   */
  updateSku: async (id, skuData) => {
    const response = await apiClient.post(`/productsku/update/${id}`, skuData);
    return response.data;
  },

  /**
   * Delete SKU
   * @param {number} id - SKU ID
   * @returns {Promise} Deletion result
   */
  deleteSku: async (id) => {
    const response = await apiClient.post(`/productsku/delete/${id}`);
    return response.data;
  },

  /**
   * Get all SKUs for the current tenant
   * @returns {Promise} Array of SKUs
   */
  getSkusByTenant: async () => {
    const response = await apiClient.get('/productsku');
    return response.data;
  },
};

export default productSkuService;
